export const USE_MOCK_DATA = process.env.REACT_APP_USE_MOCK === 'true';
export const API_URL = process.env.REACT_APP_INNHOLDSTJENESTE_API_URL;
